import React, { useContext, useEffect, useState } from 'react';
import { IonContent, IonGrid, IonRow, IonCol, IonCard, IonCardContent, IonLoading, IonToast } from '@ionic/react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router';
import { v4 as uuidv4 } from 'uuid';

// Components
import { HeaderComponent, DocumentComponent } from '../../../components';

// Helpers
import { extractConfigPage, savePageInit, resolveColorMessageByStatusCode, sendEventDocumentPage } from '../../../helpers';

// Contexts
import { AppContext } from '../../../contexts';

// Constants
import { APP_CONFIG } from '../../../constants';

// Hooks
import { useForm, useValidatorFormDocument } from '../../../hooks';

// Actions
import { startListAvailableBenefitsAction, resetErrorAction, startCreateTransactionAction, resetBenefitAction, setEntityAction } from '../../../redux';

// Sass
import './DocumentPage.scss';

export const DocumentPage = ({ menuRef, userPermission }) => {
    
    const dispatch = useDispatch();
    const { activated: benefitSelected, list: benefits } = useSelector(state => state.benefit);
    const { error } = useSelector(state => state.app);

    const [{ document }, handleInputChange, reset] = useForm({ document: '' });
    const [showToast, setShowToast] = useState({ show: false, error: null, status: null });
    const [loading, setLoading] = useState(false);

    const history = useHistory();
    const location = useLocation();
    const pageConfig = extractConfigPage(location);
    const { isWeb } = useContext(AppContext);

    const { validation, inputs } = useValidatorFormDocument(pageConfig, document);

    /**
     * Al salir de la página de Documento, se resetea el estado del error y de la información ingresada
     */
    useEffect(() => {

        savePageInit(APP_CONFIG.PAGES.DOCUMENT.path);

    }, []);

    /**
     * En caso de ocurrir cualquier error al llamar a la API; muestra el mensaje
     */
    useEffect(() => {

        if (error) {

            setShowToast({ show: true, error: error.message, status: error.status });
            dispatch(resetBenefitAction());
            dispatch(resetErrorAction());
            reset();
        }

    }, [error]);

    /**
     * Si ya se han consultado los beneficios disponibles para este subscriptor
     */
    useEffect(() => {

        if (benefits.length > 0) {

            const entity = {

                transactionId: uuidv4(),
                subscriberDni: parseInt(document),
                benefitId: benefitSelected.benefitId,
            };

            dispatch(setEntityAction(entity));

            if (entity.benefitId !== '') {

                dispatch(resetBenefitAction());

                dispatch(startCreateTransactionAction(entity, pageConfig, setLoading, history));
            }
            else {
                history.push(history.push(APP_CONFIG.PAGES.BENEFIT.path));
            }

            // Analytics
            sendEventDocumentPage();
        }

    }, [benefits]);

    /**
     * Validar el formulario y llama a la API para consultar por los beneficios disponibles
     * @param {Object} e Evento del formulario
     */
    const handleContinue = async (e) => {

        e.preventDefault();

        if (validation.formComplete && validation.formValid) {

            dispatch(startListAvailableBenefitsAction({ subscriberDni: document }, setLoading));
        }
    };


    return (
        <>
            <HeaderComponent
                title={pageConfig.title}
                menuRef={menuRef}
            />

            <IonLoading
                isOpen={loading}
                message={APP_CONFIG.CONTROLS.LOADING.MESSAGE}
            />

            <IonContent className="ion-padding">

                <IonToast
                    isOpen={showToast.show}
                    onDidDismiss={() => setShowToast(false)}
                    message={showToast.error}
                    duration={APP_CONFIG.CONTROLS.TOAST.DURATION}
                    position={APP_CONFIG.CONTROLS.TOAST.POSITION}
                    color={ resolveColorMessageByStatusCode(showToast.status) }
                />

                {/* MOBILE */}
                {!isWeb &&

                    <DocumentComponent
                        document={document == 0 ? "" : document}
                        handleContinue={handleContinue}
                        handleInputChange={handleInputChange}
                        inputs={inputs}
                        validation={validation}
                        pageConfig={pageConfig}
                        userPermission={userPermission}
                    />
                }

                {/* WEB */}
                {
                    isWeb &&
                    <IonGrid>
                        <IonRow className='ion-text-left'>
                            <IonCol>
                                <h1>Nueva transacción</h1>
                            </IonCol>
                        </IonRow>
                        <IonRow>
                            <IonCol>
                                <IonCard>
                                    <IonCardContent className="ion-text-center">

                                        <DocumentComponent
                                            document={document == 0 ? "" : document}
                                            handleContinue={handleContinue}
                                            handleInputChange={handleInputChange}
                                            inputs={inputs}
                                            validation={validation}
                                            pageConfig={pageConfig}
                                            userPermission={userPermission}
                                        />

                                    </IonCardContent>
                                </IonCard>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                }

            </IonContent>
        </>
    )
}
